import { SPEC_COURSE_LESSON_MODE } from 'common.components/spec-course-lesson-view/typings';

export const MODES_TO_ADD_STUDENTS = [SPEC_COURSE_LESSON_MODE.NO_STUDENTS];

export const MODES_TO_SHOW_TASKS = [
    SPEC_COURSE_LESSON_MODE.LESSON_IN_PROGRESS,
    SPEC_COURSE_LESSON_MODE.LESSON_ASSIGNED,

    // Мы больше не показываем кнопку "Разбор заданий"
    // для завершеннных спецпроектов
];

export const MODES_OLYMP_IN_PROGRESS = [
    SPEC_COURSE_LESSON_MODE.CONTROL_WORK_IN_PROGRESS,
    SPEC_COURSE_LESSON_MODE.CONTROL_WORK_ASSIGNED,
];

export const MODES_TO_SHOW_RESULTS = [
    SPEC_COURSE_LESSON_MODE.CONTROL_WORK_FINISHED,
    SPEC_COURSE_LESSON_MODE.LESSON_FINISHED,
];

export const LESSON_MODES = [
    SPEC_COURSE_LESSON_MODE.LESSON_IN_PROGRESS,
    SPEC_COURSE_LESSON_MODE.LESSON_ASSIGNED,
    SPEC_COURSE_LESSON_MODE.LESSON_FINISHED,
];
